import React from 'react';
import {
  Grid,
  Typography,
  TextField,
  Icon,
  IconButton,
} from '@material-ui/core';


const InformationSetup = ({ setupData, editTitle, editOption, addOption, removeOption }) => {
  const {information} = setupData;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12}>
        <Typography variant="h4" className="text-brand ml-4 mt-8">Setup Information</Typography>
      </Grid>
      {information &&
      <Grid item xs={12} sm={6}>
        <TextField
          variant="outlined"
          defaultValue={information.title}
          onBlur={(e) => editTitle('information', e.target.value)}
          fullWidth
          label={
            <div className="flex items-center">
              Title
            </div>
          }
        />
      </Grid>}
      {!information?.options?.length &&
      <IconButton
        onClick={() => addOption('information')}
        title="Add"
      >
        <Icon>add</Icon>
      </IconButton>}
      {information.options && information.options.map((option, idx) => (
        <Grid key={option._id || option.id} item xs={12} sm={12} className="flex">
          <TextField
            variant="outlined"
            defaultValue={option.label}
            name="label"
            onBlur={(e) => editOption(e, 'information', idx)}
            fullWidth
            label={
              <div className="flex items-center">
                Option {idx + 1}
              </div>
            }
            helperText={!information.options[idx]?.label?.length && 'Field is required'}
            error={!information.options[idx]?.label?.length}
          />
          <IconButton
            onClick={() => removeOption('information', idx)}
            title="Delete"
            className="h-50px"
          >
            <Icon>delete</Icon>
          </IconButton>
          <IconButton
            onClick={() => addOption('information', idx)}
            title="Add"
            className="h-50px"
          >
            <Icon>add</Icon>
          </IconButton>
        </Grid>
      ))}
    </Grid>
  );
};

export default InformationSetup;
